import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import logo from '../../assets/logolight.png'
import ConnectedButton from './ConnectedButton'
import background from '../../assets/navback.png'


const SideNavWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    // width: 100px;
    width: 20%;
    position: fixed;
    top: 0;
    left: 0;
    // background: #3c4c4b;
    background-image: url(${background});
    background-size: cover;


    transition: 850ms;
    z-index: 1000;
`

const StyledMenuItem = styled(Link)`
    color: white;
    text-decoration: none;
    font-size: 1rem;
    text-transform: uppercase;
    width: 70%;
    border-radius: 10px;
    border: 2px solid invisible;
    font-weight: 400;
    padding: 20px;
    font-family: 'Outfit','Noto Sans', sans-serif;
    &:hover {
        color: #f3d4bd;
        background-color: #3c4c4b;
       
    }
`
// fix position at the top of the navbar
const Logo = styled.img`
    width: 50px;
    height: auto;
    padding: 20px;
    position: fixed;
    top: 25px;
    // left: 0;
    z-index: 1000;
    transition: 850ms;
`


const SideNav = () => {
  return (
    <SideNavWrapper>
      <Logo src
        ={logo} alt="logo" />   
        <StyledMenuItem to="/">Dashboard</StyledMenuItem>
        <StyledMenuItem to="/market">Market</StyledMenuItem>

        <StyledMenuItem to="/history">History</StyledMenuItem>
        <StyledMenuItem to="/predictive-analytics">Predictive AI</StyledMenuItem>

        <StyledMenuItem to="/dao">DAO</StyledMenuItem>
        <StyledMenuItem to="/settings">Settings</StyledMenuItem>
        <ConnectedButton />
    </SideNavWrapper>

  )
}

export default SideNav
